import { gql } from "@apollo/client";

export const GET_CHATBOT_PREDICTION_QUERY = gql`
  query GetChatBotPrediction($input: GetChatBotPredictionInput!) {
    getChatBotPrediction(input: $input) {
      data
      success
      message
    }
  }
`;

export const GET_CONVERSATION_HISTORY_QUERY = gql`
  query GetConversationHistory {
    getConversationHistory {
        id
        title
        summary
        status
        createdAt
        updatedAt
        deletedAt
    }
}
`;
